export function formatBytes(bytes: number, decimals: number = 1) {
  if (bytes === 0) {
    return FileSizeDescriptor.ZERO_BYTES;
  }
  const k = 1000;
  const dm = decimals;
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  const fileSizeString = '' + parseFloat((bytes / Math.pow(k, i)).toFixed(dm));
  const fileSizeUnit = fileSizes[i];

  return new FileSizeDescriptor(bytes, fileSizeString, fileSizeUnit);
}
export type FileSource = 'IMAGE' | 'GENERIC';

const fileSizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

let fileDescriptorIndex = 0;

export class FileDescriptor {
  private readonly _index: number;
  fileName?: string = undefined;
  fileSize?: FileSizeDescriptor = undefined;
  fileSource: FileSource;

  constructor(fileSource: FileSource = 'GENERIC') {
    this._index = ++fileDescriptorIndex;
    this.fileSource = fileSource;
  }

  get index() {
    return this._index;
  }

  useFile(file: File) {
    this.fileName = file.name;
    this.fileSize = formatBytes(file.size);
  }

  isConfigured(): boolean {
    return !!this.fileName && !!this.fileSize;
  }
}

export class FileSizeDescriptor {
  readonly valueInBytes: number;
  readonly value: string;
  readonly unit: string;

  constructor(bytes: number, value: string, unit: string) {
    this.valueInBytes = bytes;
    this.value = value;
    this.unit = unit;
  }

  static ZERO_BYTES = new FileSizeDescriptor(0, '0', fileSizes[0]);
}

export const encodeFileInBase64 = (file: File): Promise<File> => {
  const fileReader = new FileReader();
  return new Promise((resolve, reject) => {
    fileReader.onloadend = () => {
      resolve(new File([btoa(fileReader.result as string)], file.name, { type: file.type }));
    };
    fileReader.onerror = () => {
      reject(new Error(`Error reading file: ${file.name}`));
    };
    fileReader.readAsBinaryString(file);
  });
};
